module.exports = __webpack_public_path__ + "public/img/image-5.63d34a1d.png";